








































import { Component, Vue } from "vue-property-decorator";
import { apiClient } from "../../api/ApiClient";
import moment from "moment";
import {
  createNotify,
  updateNotify,
  deleteNotify,
  notifyError,
  notifyErrorThrow
} from "@/utils/formHelper";
import TickCross from "@/components/TickCross.vue";
import JsonEditor from "@/components/JsonEditor.vue";

@Component({
  components: {
    TickCross,
    JsonEditor
  },
})
export default class extends Vue {

  // form
  public get rules() {
    return {
      key: [
        {
          required: true,
          trigger: "blur",
          message: this.$t('form["this field is required"]')
        }
      ],
    };
  }

  public get formTitle() {
    switch (this.formState) {
      case "create":
        return this.$t('global["Create"]');
      case "edit":
        return this.$t('global["Edit"]');
      default:
        return "";
    }
  }
  public formState: string = "create";

  public form: any = {};
  public formJsonEditorValue: any = null;

  // filter
  public key = '';

  // table
  public currentPage = 1;
  public pageSize = 100;
  public count = 1;

  public formVisible = false;
  public isTableLoading = false;
  public data: any[] = [];
  public get filteredData() {
    return this.data.filter(p =>
      (!this.key || p.key.includes(this.key))
    );
  }

  public mounted() {
    this.init();
  }

  // form
  public async onEditClick(row: any) {
    const form = { ...row };
    try {
      this.formJsonEditorValue = typeof row.value === 'string' ? row.value : JSON.parse(row.value);
    } catch(e) {

    }

    this.formState = "edit";
    this.form = form;
    this.clearFormValidations();
    this.formVisible = true;
  }

  public onFormCancel() {
    this.formVisible = false;
  }

  public async onFormConfirm() {
    if (this.formState === "create") {
      // this.onCreateConfirm();
    } else {
      this.onEditConfirm();
    }
  }

  //
  public async onPaginationChange() {
    await this.loadSettings();
    this.$scrollTo("#data-table");
  }

  //
  private async init() {
    await this.loadSettings();
  }

  private async loadSettings() {
    this.isTableLoading = true;
    const { data } = await apiClient.settings({
      take: this.pageSize,
      page: this.currentPage
    });
    // this.count = data.count;
    // this.data = data.data;
    this.data = data;
    this.isTableLoading = false;
  }

  // events
  private async onEditConfirm() {
    try {
      this.validateForm();
    } catch (e) {
      console.error(e);
      return;
    }

    const loading = this.$loading({});
    try {
      await apiClient.putSettings(this.form.id, this.form);
      this.formVisible = false;
      updateNotify.bind(this)();
    } catch (e) {
      throw e;
    } finally {
      loading.close();
    }

    await this.loadSettings();
  }

  //
  private clearFormValidations() {
    if (this.$refs.form) {
      (this.$refs.form as any).clearValidate();
    }
  }

  private validateForm() {
    try {
      this.form.value = JSON.parse((this.$refs.jsonEditor as any).getValue());
    } catch (e) {
      notifyErrorThrow.bind(this)("meta data json syntax error");
    }
  }

}
